import { INVOICES_INITIAL_STATE, setDates, setFilterType, setFilterValue } from 'store/models/invoices';

const setDefaultFilter = () => {
    return (dispatch) => {
        dispatch([
            setDates({ from: INVOICES_INITIAL_STATE.from, to: INVOICES_INITIAL_STATE.to }),
            setFilterType(INVOICES_INITIAL_STATE.filterType),
            setFilterValue(INVOICES_INITIAL_STATE.filterValue),
        ]);
    };
};

export default setDefaultFilter;
